
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import logo from "../assets/mitsulift-logo-512.png";
export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    self.$setState({
      user: window.identity
    }, function () {}); // Loading flag

    var allowInfinite = true; // Attach 'infinite' event handler
    //console.log($$('.news-infinite-scroll-content'));

    $$('.news-infinite-scroll-content').on('infinite', function () {
      // Exit, if loading in progress
      if (!allowInfinite) return; // Set loading flag

      allowInfinite = false; //console.log("Infinite");

      self.loadArticles(function () {
        // Reset loading flag
        allowInfinite = true;
      });
    });
    self.checkNotificationsCount();
    self.getNewLocations();

    if (!window.IS_WEBAPP) {
      setTimeout(function () {
        self.checkSilentUpdate();
      }, 2000);
    }

    $$('.news-ptr-content').on('ptr:refresh', function (e) {
      //console.log("ptr:refresh");
      self.$setState({
        nextPage: {
          href: Url.to("news/articles?per-page=3")
        },
        news: []
      }, function () {});
      self.$tick(function () {
        self.checkNotificationsCount();
        self.getNewLocations();
        self.loadArticles(function () {
          // Reset loading flag
          app.ptr.done('.news-ptr-content');
          app.infiniteScroll.create('.news-infinite-scroll-content'); //$$('.notifications-infinite-scroll-content .infinite-scroll-preloader').removeClass("display-none");
        });
      });
    });
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; //Get articles
    // $$("#view-home").once("tab:show", function () {

    self.loadArticles(function () {}); // });
    // $$("#view-home").on("tab:show", function () {
    //     console.log("SHOWN")
    //    if(window.newsRequireRefresh){
    //        window.newsRequireRefresh = false;
    //        $$("#view-home").off("tab:show");
    //        self.$router.refreshPage()
    //    }
    // });
  },
  methods: {
    checkNotificationsCount() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("notification/unread"),
        preloader: false,
        progress: false,
        success: function (data, status, xhr) {
          //console.log(data);
          if (data['count'] > 0) {
            $$("#notifications-count").text(data['count']);
            $$("#notifications-count").removeClass("display-none");
          }

          setTimeout(() => {
            if (self) {
              self.checkNotificationsCount();
            }
          }, 30000);
          $$("#other-countries-notifications").addClass("display-none");
          Object.keys(data['countries']).forEach(function (country) {
            if (window.country != country) {
              if (data['countries'][country] > 0) {
                $$("#other-countries-notifications").removeClass("display-none");
              }
            }
          });
        }
      });
    },

    checkSilentUpdate() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("data/check-update"),
        data: {
          version: window.appVersionLabel,
          platform: self.$app.device.os
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);

          if (data['update']) {
            console.log("UPDATE REQUIRED");
            self.showUpdateModal(data['link']);
          } else {
            console.log("Latest Version");
          }

          setTimeout(() => {
            self.checkSilentUpdate();
          }, 5 * 60 * 1000); //every 5 minutes
        }
      });
    },

    showUpdateModal(link) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var alert = self.$app.dialog.alert('A new version is available to download. Please update to continue using the app?', function () {
        if (window.cordova) {
          window.cordova.InAppBrowser.open(link, '_system');
        } else {
          window.open(link, "_system");
        }
      });
      alert.on('close', () => {
        self.showUpdateModal(link);
      });
      console.log(alert);
    },

    getNewLocations: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("location/get-new"),
        preloader: false,
        progress: false,
        success: function (data, status, xhr) {
          if (data['new']) {
            var dialog = self.$app.dialog.alert(data['message']);
            $$(dialog.el).find(".dialog-text").addClass("text-align-left");
          }
        }
      });
    },
    readArticle: function (id) {
      //console.log(id);
      var self = this;
      var app = self.$app;
      var router = self.$router;
      var article = {};
      self.news.forEach(function (art) {
        if (art.id === id) {
          article = art;
          return false;
        }
      });
      router.navigate("/article/", {
        context: {
          article: article
        }
      });
    },
    loadArticles: function (callback) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (self.nextPage) {
        app.request({
          url: self.nextPage['href'],
          preloader: false,
          progress: true,
          data: {
            "per-page": window.IS_WEBAPP ? 6 : 4
          },
          success: function (data, status, xhr) {
            //console.log("News", data, data['links']['next']);
            self.$setState({
              news: self.news.concat(data['items']),
              nextPage: data['links']['next']
            }, function () {
              if (!self.nextPage) {
                app.infiniteScroll.destroy('.news-infinite-scroll-content');
                $$('.news-infinite-scroll-content .infinite-scroll-preloader').remove();
              } //autoplay videos
              // console.log(">>>>",$$("video:not(.loaded)"))


              $$("video:not(.loaded)").forEach(video => {
                // console.log(video);
                video.muted = true;
                video.load();
                video.play();
                $$(video).addClass("loaded");
              });
            });
            self.$tick(function () {
              callback();
            });
          }
        });
      } else {
        app.infiniteScroll.destroy('.news-infinite-scroll-content');
        $$('.news-infinite-scroll-content .infinite-scroll-preloader').remove();
      }
    }
  },
  on: {
    pageBeforeIn: function (a, b, c) {
      var self = this;
      self.$setState({
        user: window.identity
      }, function () {});
    }
  },
  data: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    console.log(app.device.os.toLowerCase());
    return {
      nextPage: {
        href: Url.to("news/articles")
      },
      news: [],
      user: window.identity,
      logo: logo,
      platform: app.device.os.toLowerCase(),
      two_columns: window.IS_WEBAPP
    };
  },
  id: '6169ab147c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page navbar-extra-large with-navbar-fixed" data-name="news">\n        <!-- Top Navbar -->\n        <div class="navbars navbar-hidden navbar-large-hidden"></div>\n        <div class="page-content news-infinite-scroll-content infinite-scroll-content\n        news-ptr-content ptr-content">\n            <div class="navbar navbar-large navbar-extra-large navbar-fixed">\n                <div class="navbar-bg"></div>\n                <div class="navbar-inner">\n                    <div class="left"></div>\n                    <div class="title sliding"></div>\n                    <div class="title-large">\n                        <div class="title-large-text">hello ';
      r += c(ctx_1.user.firstname, ctx_1);
      r += ',\n                            <div class="right" style="top:0">\n                                <a class="link icon-only no-margin-left text-color-gray tab-link" href="#view-notifications">\n                                    <i class="icon f7-icons">\n                                        bell\n                                        <span id="notifications-count" class="badge color-red display-none"></span>\n                                    </i>\n                                </a>\n                            </div>\n                            <div class="right display-none" style="top:0">\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.facebook.com/mitsuliftgroup">\n                                    <i class="icon f7-icons">logo_facebook</i>\n                                </a>\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.linkedin.com/company/mitsulift-group/">\n                                    <i class="icon f7-icons">logo_linkedin</i>\n                                </a>\n                                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.instagram.com/mitsuliftgroup/">\n                                    <i class="icon f7-icons">logo_instagram</i>\n                                </a>\n                            </div>\n                            <div class="subtitle-text"></div>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n            <div class="ptr-preloader">\n                <div class="preloader"></div>\n                <div class="ptr-arrow"></div>\n            </div>\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.two_columns, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="row">\n                <div class="col-100 medium-50">\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.news, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, "parseInt(@index) % 2 == 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="block article-block no-hairlines">\n                        <bdi class="article-category" style="font-size: 13px;color: rgb(153,153,153)">';
                  r += c(ctx_4.category, ctx_4);
                  r += '</bdi>\n                        <bdi class="article-title">';
                  r += c(ctx_4.title, ctx_4);
                  r += '</bdi>\n                        <bdi class="article-subtitle">';
                  r += c(ctx_4.subtitle, ctx_4);
                  r += '</bdi>\n                        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.video_preview, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <video  @click="readArticle(';
                      r += c(ctx_5.id, ctx_5);
                      r += ')" muted="muted" autoplay="autoplay" playsinline preload="auto" width="100%" loop="loop"\n                                data-src="';
                      r += c(ctx_5.video_preview, ctx_5);
                      r += '" id="video-preview-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" poster="';
                      r += c(ctx_5.image_thumb_1024_url, ctx_5);
                      r += '"   oncanplay="this.muted=true">\n                            <source src="';
                      r += c(ctx_5.video_preview, ctx_5);
                      r += '" type="video/mp4">\n                        </video>\n                        ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <div  @click="readArticle(';
                      r += c(ctx_5.id, ctx_5);
                      r += ')" class="article-image" style="background-image: url(';
                      r += c(ctx_5.image_thumb_1024_url, ctx_5);
                      r += ')"></div>\n                        ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                        <div class="article-footer">\n                            <a @click="readArticle(';
                  r += c(ctx_4.id, ctx_4);
                  r += ')" data-id="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" href="#">\n                                Find out more\n                                <i class="icon f7-icons">chevron_right</i>\n                            </a>\n                        </div>\n                    </div>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n                <div class="col-100 medium-50">\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.news, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              r += Template7Helpers.js_if.call(ctx_3, "parseInt(@index) % 2 != 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <div class="block article-block no-hairlines">\n                        <bdi class="article-category" style="font-size: 13px;color: rgb(153,153,153)">';
                  r += c(ctx_4.category, ctx_4);
                  r += '</bdi>\n                        <bdi class="article-title">';
                  r += c(ctx_4.title, ctx_4);
                  r += '</bdi>\n                        <bdi class="article-subtitle">';
                  r += c(ctx_4.subtitle, ctx_4);
                  r += '</bdi>\n                        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.video_preview, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <video  @click="readArticle(';
                      r += c(ctx_5.id, ctx_5);
                      r += ')" muted="muted" autoplay="autoplay" playsinline preload="auto" width="100%" loop="loop"\n                                data-src="';
                      r += c(ctx_5.video_preview, ctx_5);
                      r += '" id="video-preview-';
                      r += c(ctx_5.id, ctx_5);
                      r += '" poster="';
                      r += c(ctx_5.image_thumb_1024_url, ctx_5);
                      r += '"   oncanplay="this.muted=true">\n                            <source src="';
                      r += c(ctx_5.video_preview, ctx_5);
                      r += '" type="video/mp4">\n                        </video>\n                        ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                        <div  @click="readArticle(';
                      r += c(ctx_5.id, ctx_5);
                      r += ')" class="article-image" style="background-image: url(';
                      r += c(ctx_5.image_thumb_1024_url, ctx_5);
                      r += ')"></div>\n                        ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                        <div class="article-footer">\n                            <a @click="readArticle(';
                  r += c(ctx_4.id, ctx_4);
                  r += ')" data-id="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" href="#">\n                                Find out more\n                                <i class="icon f7-icons">chevron_right</i>\n                            </a>\n                        </div>\n                    </div>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n            </div>\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.video_preview, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.news, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="block article-block no-hairlines">\n                <bdi class="article-category" style="font-size: 13px;color: rgb(153,153,153)">';
              r += c(ctx_3.category, ctx_3);
              r += '</bdi>\n                <bdi class="article-title">';
              r += c(ctx_3.title, ctx_3);
              r += '</bdi>\n                <bdi class="article-subtitle">';
              r += c(ctx_3.subtitle, ctx_3);
              r += '</bdi>\n                ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.video_preview, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <video  @click="readArticle(';
                  r += c(ctx_4.id, ctx_4);
                  r += ')" muted="muted" autoplay="autoplay" playsinline preload="auto" width="100%" loop="loop"\n                        data-src="';
                  r += c(ctx_4.video_preview, ctx_4);
                  r += '" id="video-preview-';
                  r += c(ctx_4.id, ctx_4);
                  r += '" poster="';
                  r += c(ctx_4.image_thumb_1024_url, ctx_4);
                  r += '"   oncanplay="this.muted=true">\n                    <source src="';
                  r += c(ctx_4.video_preview, ctx_4);
                  r += '" type="video/mp4">\n                </video>\n                ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div  @click="readArticle(';
                  r += c(ctx_4.id, ctx_4);
                  r += ')" class="article-image" style="background-image: url(';
                  r += c(ctx_4.image_thumb_1024_url, ctx_4);
                  r += ')"></div>\n                ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                <div class="article-footer">\n                    <a @click="readArticle(';
              r += c(ctx_3.id, ctx_3);
              r += ')" data-id="';
              r += c(ctx_3.id, ctx_3);
              r += '" href="#">\n                        Find out more\n                        <i class="icon f7-icons">chevron_right</i>\n                    </a>\n                </div>\n            </div>\n            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <br/>\n            <br/>\n            <br/>\n            <div class="preloader infinite-scroll-preloader"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    